import "./UpdateTicketLocalSite.scss";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import newRequest from "../../../context/newRequest";
import { sleep } from "../../../helper/helper";

const UpdateTicketLocalSite = ({ inputs, title }) => {
    const [ticketLocalsite, setticketLocalsite] = useState({});
    const [ticketUpdateLocalsite, setticketUpdateLocalsite] = useState({});
    const [categoryId, setCategoryId] = useState(false);
    const [statusId, setStatusId] = useState(false);
    const [sending, setSending] = useState("");
    const { ticketId } = useParams();
    const { data } = useFetch(`/ticketsite/${ticketId}`);
    const navigate = useNavigate();

    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            setticketLocalsite(data);
            setticketUpdateLocalsite({
                customer_site: data.customer_site || "",
                vendor_id: data.vendor_id || "",
                root_cause: data.root_cause || "",
                action: data.action || "",
                note: data.note || "",
                pop_id: data.pop_id || "",
            });
            if (data.status_id) {
                setStatusId([data.status_id]);
            }
            if (data.category_id) {
                setCategoryId([data.category_id]);
            }
        }
    }, [data]);

    const handleSelectCategoryID = (e) => {
        const value = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        );
        setCategoryId(value);
    };

    const handleSelectStatusID = (e) => {
        const value = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        );
        setStatusId(value);
    };

    const handleChange = (e) => {
        setticketUpdateLocalsite((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };

    const handleClick = async (e) => {
        e.preventDefault();
        setSending("Mengirim Data...");
        try {
            const newTicketUpdate = {
                ...ticketUpdateLocalsite,
                category_id: categoryId && categoryId.length > 0 ? categoryId[0] : (ticketLocalsite.category_id || ""),
                status_id: statusId && statusId.length > 0 ? statusId[0] : (ticketLocalsite.status_id || "OPEN")
            };

            const res = await newRequest.put(`/ticketsite/${ticketId}`, newTicketUpdate);
            if (res.status === 200) {
                setSending("Berhasil Mengirim Data");
                await sleep(1500);
                navigate(`/ticketsite/${ticketId}`);
            }
        } catch (err) {
            console.error("Error updating ticket local site:", err);
            const errMsg = err.response?.data?.errors || err.response?.data?.message || err.message || "Gagal mengupdate tiket";
            setSending(errMsg);
        }
    };

    return (
        <div className="new">
            <Sidebar />
            <div className="newContainer">
                <Navbar />
                <div className="top">
                    <h1>{title}</h1>
                </div>
                <div className="bottom">
                    <div className="right">
                        <div className="detailItem">
                            <span className="itemKey">Ticket ID:</span>
                            <span className="itemValue">{ticketId}</span>
                        </div>
                        <div className="detailItem">
                            <span className="itemKey">Site Customer:</span>
                            <span className="itemValue">{ticketLocalsite.customer_site}</span>
                        </div>
                        <form>
                            {inputs && inputs.map((input) => (
                                <div className="formInput" key={input.id}>
                                    <label>{input.label}</label>
                                    {input.id === "note" ? (
                                        <textarea
                                            id={input.id}
                                            placeholder={ticketLocalsite.note || input.placeholder}
                                            value={ticketUpdateLocalsite[input.id] ?? ""}
                                            onChange={handleChange}
                                            rows="3"
                                            style={{
                                                width: "100%",
                                                padding: "8px 10px",
                                                border: "1px solid #cbd5e1",
                                                borderRadius: "6px",
                                                fontFamily: "inherit",
                                                fontSize: "14px",
                                                resize: "vertical",
                                                marginTop: "5px",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    ) : (
                                        <input
                                            type={input.type}
                                            placeholder={ticketLocalsite[input.id] || input.placeholder}
                                            value={ticketUpdateLocalsite[input.id] ?? ""}
                                            onChange={handleChange}
                                            id={input.id}
                                        />
                                    )}
                                </div>
                            ))}

                            {(!inputs || !inputs.some((input) => input.id === "note")) && (
                                <div className="formInput">
                                    <label>Note (Catatan Tiket)</label>
                                    <textarea
                                        id="note"
                                        placeholder={ticketLocalsite.note || "Catatan tiket..."}
                                        value={ticketUpdateLocalsite.note ?? ""}
                                        onChange={handleChange}
                                        rows="3"
                                        style={{
                                            width: "100%",
                                            padding: "8px 10px",
                                            border: "1px solid #cbd5e1",
                                            borderRadius: "6px",
                                            fontFamily: "inherit",
                                            fontSize: "14px",
                                            resize: "vertical",
                                            marginTop: "5px",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </div>
                            )}

                            <div className="formInput">
                                <label className="label">Category ID</label>
                                <select
                                    id="category_id"
                                    value={categoryId && categoryId.length > 0 ? categoryId[0] : (ticketLocalsite.category_id || "")}
                                    onChange={handleSelectCategoryID}
                                >
                                    <option value="">Pilih Category Id</option>
                                    <option value="Internal Distribusi Issue">Internal Distribusi Issue</option>
                                    <option value="Vendor Device Problem">Vendor Device Problem</option>
                                    <option value="Fiber Cut">Fiber Cut</option>
                                    <option value="Electrical Issue">Electrical Issue</option>
                                    <option value="DOWN">Down</option>
                                    <option value="UP">UP Internet</option>
                                    <option value="ONUBAD">ONU Bad</option>
                                    <option value="FIBERCUT">Fiber Cut</option>
                                    <option value="INTERMITTEN">INTERMITTEN</option>
                                    <option value="LOOPING">LOOPING</option>
                                    <option value="BENDING">BENDING</option>
                                    <option value="ELECTRICAL">ELECTRICAL</option>
                                </select>
                            </div>

                            <div className="formInput">
                                <label className="label">Status Id</label>
                                <select
                                    id="status_id"
                                    value={statusId && statusId.length > 0 ? statusId[0] : (ticketLocalsite.status_id || "OPEN")}
                                    onChange={handleSelectStatusID}
                                >
                                    <option value="">Update Status Ticket</option>
                                    <option value="OPEN">OPEN</option>
                                    <option value="PENDING">PENDING</option>
                                    <option value="SOLVED">SOLVED</option>
                                    <option value="CLOSED">CLOSED</option>
                                    <option value="CANCELED">CANCELED</option>
                                </select>
                            </div>

                            <button onClick={handleClick} disabled={sending === "Mengirim Data..."}>
                                {sending === "Mengirim Data..." ? "Menyimpan..." : "Update Ticket"}
                            </button>
                        </form>
                    </div>
                </div>
                {sending && <p className="error">{sending}</p>}
                <br /><br /><br /><br /><br />
            </div>
        </div>
    );
};

export default UpdateTicketLocalSite;
